import SortAndFilter from './components/SortAndFilter';

export default SortAndFilter;
